export default {
  title: 'PayPal (bezpośredni)',
  description:
    'Połącz własne konto PayPal Business, aby przyjmować płatności PayPal bezpośrednio, według własnej stawki. Utwórz aplikację REST w PayPal Developer Dashboard i wklej jej Client ID oraz Secret poniżej.',
  connected_description: 'Twoje konto PayPal jest połączone. Płatności będą rozliczane bezpośrednio na nim.',
  guide: {
    title: 'Jak uzyskać dane logowania PayPal',
    step1: 'Zaloguj się do PayPal Developer Dashboard przy użyciu konta PayPal Business.',
    step2: 'Otwórz „Apps & Credentials" i utwórz aplikację (lub otwórz istniejącą).',
    step3: 'Skopiuj Client ID i Secret aplikacji.',
    step4: 'Wklej je poniżej i kliknij „Połącz PayPal".',
    environment_note:
      'Użyj danych Live do prawdziwych płatności — przełącz przełącznik Sandbox/Live na górze „Apps & Credentials".',
    open_dashboard: 'Otwórz PayPal Developer Dashboard',
  },
  status: {
    connected: 'Połączono',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Client ID aplikacji REST PayPal',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secret aplikacji REST PayPal',
    },
  },
  buttons: {
    connect: 'Połącz PayPal',
    disconnect: 'Rozłącz',
  },
  toasts: {
    connected: 'PayPal został pomyślnie połączony',
    connect_failed: 'Nie udało się połączyć PayPal',
    disconnected: 'PayPal rozłączony',
    disconnect_failed: 'Nie udało się rozłączyć PayPal',
  },
};
